"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    marko_component = {
    onCreate: function ({status, provider}) {
        this.state = { canJoin: false };
        if (status == 'ended')
            return;
        if ([
                2,
                5
            ].includes(Number(provider.details.type))) {
            const jbt_allowed = moment(provider.details.start_time).subtract(30, 'minutes');
            this.state.canJoin = !moment().isBefore(jbt_allowed);
            if (!this.state.canJoin)
                this.checkTimeUp = setInterval(() => {
                    if (moment().isBefore(jbt_allowed))
                        return;
                    this.state.canJoin = true;
                    clearInterval(this.checkTimeUp);
                }, 15000);
        } else
            this.state.canJoin = true;
    },
    onDestroy: function () {
        clearInterval(this.checkTimeUp);
    }
},
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/components/Card-LiveSession.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    module_moment = require("moment"),
    moment = module_moment.default || module_moment,
    Button_template = require("../../components/Button/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Button_tag = marko_loadTag(Button_template),
    Locale_template = require("../../components/Locale/index.marko"),
    Locale_tag = marko_loadTag(Locale_template),
    Bx_template = require("../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    Image_template = require("../../components/Image/index.marko"),
    Image_tag = marko_loadTag(Image_template),
    WSAdapt_template = require("../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    marko_attrs0 = {
        "class": "card meeting-card item"
      },
    marko_attrs1 = {
        "class": "card-content"
      },
    marko_attrs2 = {
        "class": "card-body"
      },
    marko_attrs3 = {
        "class": "row"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("37febf"),
    marko_node0 = marko_createElement("div", {
        "class": "card-x-icon col-3"
      }, "5", null, 1, 0, {
        i: marko_const_nextId()
      })
      .e("i", {
          "class": "bx bx-play-circle"
        }, null, null, 0),
    marko_attrs4 = {
        "class": "col right-align pt-3"
      },
    marko_attrs5 = {
        "class": "col"
      },
    marko_attrs6 = {
        "class": "card-title mt-6"
      },
    marko_attrs7 = {
        "class": "blue-grey-text"
      },
    marko_node1 = marko_createElement("small", null, "14", null, 1, 0, {
        i: marko_const_nextId()
      })
      .t("Last Sunday at 03:30pm"),
    marko_attrs8 = {
        "class": "card-text mt-4"
      },
    marko_attrs9 = {
        "class": "card-bottom"
      },
    marko_attrs10 = {
        "class": "btn btn-outline-success btn-lg btn-block"
      },
    marko_attrs11 = {
        "class": "card-body"
      },
    marko_attrs12 = {
        "class": "row"
      },
    marko_attrs13 = {
        "class": "card-x-icon col-3"
      },
    marko_attrs14 = {
        "class": "card-title mt-6"
      },
    marko_attrs15 = {
        "class": "blue-grey-text"
      },
    marko_attrs16 = {
        "class": "card-bottom"
      },
    marko_attrs17 = {
        "class": "col right-align pt-3"
      },
    marko_node2 = marko_createElement("br", null, "27", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs18 = {
        "class": "d-block",
        style: "margin-top:-7px;"
      },
    marko_attrs19 = {
        "class": "card-text mt-4"
      };

function render(input, out, __component, component, state) {
  var data = input;

  const { sessionId, type, provider, topic, description, schedules, moderators, created, updated } = input

  WSAdapt_tag({
      ns: "col-xl-3 col-lg-4 col-sm-6",
      qs: "col-xl-4 col-lg-6",
      hs: "col-xl-6 col-lg-12",
      renderBody: function(out) {
        out.be("div", marko_attrs0, "1", component);

        out.be("div", marko_attrs1, "2", component);

        if (input.recording) {
          out.be("div", marko_attrs2, "3", component);

          out.be("div", marko_attrs3, "4", component);

          out.n(marko_node0, component);

          out.be("div", marko_attrs4, "7", component);

          out.be("div", marko_attrs5, "8", component);

          Button_tag({
              icon: "bx-heart",
              activeIcon: "bx-heart",
              class: "mr-3 font-large-1",
              activeClass: "text-primary",
              title: "Like"
            }, out, __component, "9");

          Button_tag({
              icon: "bx-video",
              activeIcon: "bxs-video",
              class: "mr-3 font-large-1",
              activeClass: "text-primary",
              title: "Watch Later"
            }, out, __component, "10");

          out.ee();

          out.ee();

          out.ee();

          out.be("h4", marko_attrs6, "11", component);

          Locale_tag({
              renderBody: function(out) {
                out.t("Emotional Intelligence Conversation");
              }
            }, out, __component, "12");

          out.ee();

          out.be("div", marko_attrs7, "13", component);

          out.n(marko_node1, component);

          out.be("p", marko_attrs8, "15", component);

          Locale_tag({
              renderBody: function(out) {
                out.t("Proin eget tortor risus. Vivamus magna justo, lacinia eget consectetur sed, convallis at tellus.");
              }
            }, out, __component, "16");

          out.ee();

          out.ee();

          out.ee();

          out.be("div", marko_attrs9, "17", component);

          out.be("button", marko_attrs10, "18", component);

          Locale_tag({
              text: "Watch Playback"
            }, out, __component, "19");

          out.ee();

          out.ee();
        } else {
          out.be("div", marko_attrs11, "20", component);

          out.be("div", marko_attrs12, "21", component);

          out.be("div", marko_attrs13, "22", component);

          Bx_tag({
              type: type == "meeting" ? "camera-home" : "slideshow"
            }, out, __component, "23");

          out.ee();

          if (moderators && moderators.length) {
            const { name, photo, title } = moderators[0]

            out.be("div", marko_attrs17, "24", component);

            Image_tag({
                alt: "avatar",
                src: photo,
                style: "width:35px;height:35px",
                class: "avatar mr-4 theme-bg-fade"
              }, out, __component, "25");

            out.e("span", null, "26", component, 1)
              .t(name, component);

            out.n(marko_node2, component);

            out.e("small", marko_attrs18, "28", component, 1)
              .t(title, component);

            out.ee();
          }

          out.ee();

          out.e("h4", marko_attrs14, "29", component, 1)
            .t(topic, component);

          out.e("div", marko_attrs15, "30", component, 2)
            .e("small", null, "31", component, 1)
              .t(schedules.length ? formatDate(schedules[0].start, "calendar") : formatDate(updated ? updated.at : created.at, "calendar"), component)
            .e("p", marko_attrs19, "32", component, 1)
              .t(description, component);

          out.ee();

          out.be("div", marko_attrs16, "33", component);

          out.be("button", {
              "class": "btn btn-success btn-lg btn-block",
              disabled: !state.canJoin
            }, "34", component, null, 0, {
              onclick: __component.d("click", () => state.canJoin && component.emit('join', type, provider.type, sessionId ), false)
            });

          Locale_tag({
              text: state.canJoin ? "Join" : "Scheduled"
            }, out, __component, "35");

          out.ee();

          out.ee();
        }

        out.ee();

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    e_: marko_componentType
  }, marko_component);

marko_template.Component = marko_defineComponent(marko_component, marko_template._);
